const postcode = () => {
    function valid_postcode(postcode) {
        postcode = postcode.replace(/\s/g, "");
        var regex = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
        return regex.test(postcode);
    }

    $('body').on('click', '#js__filter-locations', function (e) {
        e.preventDefault();

        let postcode = $(this).parents('.l-filter__input-wrap').find('#postcode').val();
        let type = ($(this).hasClass('full')) ? 'full' : 'small';

        postcodeFilter(postcode, type);
    });

    $('body').on('click', '.js__all-locations', function (e) {
        e.preventDefault();
        let type = ($(this).hasClass('full')) ? 'full' : 'small';
        allLocations(type);
    });

    function postcodeFilter(postcode, type) {
        $('.form__error-message-container').addClass('d-none');
        let loader = '<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>';
        let wrapper = '#location-posts';

        if (valid_postcode(postcode)) {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'postcode_search',
                    postcode: postcode,
                    type: type,
                },
                beforeSend: function () {
                    $(wrapper).fadeTo(200, 0, function () {
                        $('.l-filter__loader').html(loader);
                        $(wrapper).empty();
                    });
                    $(wrapper).delay(400).fadeTo(900, 1);
                },
                success: function (data) {
                    $(wrapper).delay(200).fadeIn(300, function () {
                        $('.l-filter__loader .loader').remove();
                        $(wrapper).append(data);
                        initScrollingAnimations();
                        lineAnimation('locations');
                    });
                },
                error: function (data) {
                    console.log(data);
                }
            });
        }
    }

    function allLocations(type) {
        $('.form__error-message-container').addClass('d-none');
        let loader = '<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>';
        let wrapper = '#location-posts';

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'all_locations',
                    type: type,
                },
                beforeSend: function () {
                    $(wrapper).fadeTo(200, 0, function () {
                        $('.l-filter__loader').html(loader);
                        $(wrapper).empty();
                    });
                    $(wrapper).delay(400).fadeTo(900, 1);
                },
                success: function (data) {
                    $(wrapper).delay(200).fadeIn(300, function () {
                        $('.l-filter__loader .loader').remove();
                        $(wrapper).append(data);
                        initScrollingAnimations();
                        lineAnimation('locations');
                    });
                }
            });
    }

    $('#js__geo').on('click', function(e) {
        e.preventDefault();

        $('.form__error-message-container').addClass('d-none');

        let startPos;
        let pcInputField = $('#postcode');

        let geoSuccess = function(position) {
            startPos = position;

            let apiURL = 'https://api.postcodes.io/postcodes?lon=' + startPos.coords.longitude + '&lat=' + startPos.coords.latitude;

            $.get(apiURL, function(data, status){
                if ( data.result != null ) {
                    let postcode = data.result[0].postcode;

                    let type = ($(this).hasClass('full')) ? 'full' : 'small';
                    postcodeFilter(postcode, type);
                }
            });
        };

        let geoError = function(error) {
            let errorMessage;

            switch(error.code) {
                case error.PERMISSION_DENIED:
                    errorMessage = "Geolocation request denied. Please enter postcode manually."
                    break;
                case error.POSITION_UNAVAILABLE:
                    errorMessage = "Location information is unavailable. Please enter postcode manually."
                    break;
                case error.TIMEOUT:
                    errorMessage = "The request to get your postcode timed out. Please enter postcode manually."
                    break;
                case error.UNKNOWN_ERROR:
                    errorMessage = "An error occurred. Please enter postcode manually."
                    break;
                default:
                    errorMessage = "An error occurred. Please enter postcode manually."
            }

            $('.form__error-message').html(errorMessage);
            $('.form__error-message-container').removeClass('d-none');
        };

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
    });

}